// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3PxYO","tab":"ProcedureTabs_tab__forCL"};